import { z } from "zod"
import { CustomerSchema } from "./customer"

export const CampaignExecutionSchema = z.object({
  id: z.number(),
  customer: CustomerSchema.nullish(),
  campaign_name: z.string(),
  campaign_id: z.string(),
  status: z.enum(["started", "completed", "failed", "cancelled"]),
  current_step_index: z.number().nullable(),
  total_steps: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
  error_message: z.string().nullable(),
})

export type CampaignExecution = z.infer<typeof CampaignExecutionSchema>
